/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Voice_Manager_Styles_Count_BadgeInputs */

const en_voice_manager_styles_count_badge = /** @type {(inputs: Voice_Manager_Styles_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} styles`)
};

const fr_voice_manager_styles_count_badge = /** @type {(inputs: Voice_Manager_Styles_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} styles`)
};

const de_voice_manager_styles_count_badge = /** @type {(inputs: Voice_Manager_Styles_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Stile`)
};

const it_voice_manager_styles_count_badge = /** @type {(inputs: Voice_Manager_Styles_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} stili`)
};

const ru_voice_manager_styles_count_badge = /** @type {(inputs: Voice_Manager_Styles_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} стилей`)
};

const es_voice_manager_styles_count_badge = /** @type {(inputs: Voice_Manager_Styles_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} estilos`)
};

const zh_cn2_voice_manager_styles_count_badge = /** @type {(inputs: Voice_Manager_Styles_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 种风格`)
};

const ja_voice_manager_styles_count_badge = /** @type {(inputs: Voice_Manager_Styles_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} スタイル`)
};

const hi_voice_manager_styles_count_badge = /** @type {(inputs: Voice_Manager_Styles_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} शैलियाँ`)
};

const pt_pt2_voice_manager_styles_count_badge = /** @type {(inputs: Voice_Manager_Styles_Count_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} estilos`)
};

/**
* | output |
* | --- |
* | "{count} styles" |
*
* @param {Voice_Manager_Styles_Count_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_styles_count_badge = /** @type {((inputs: Voice_Manager_Styles_Count_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Styles_Count_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_styles_count_badge(inputs)
	if (locale === "de") return de_voice_manager_styles_count_badge(inputs)
	if (locale === "it") return it_voice_manager_styles_count_badge(inputs)
	if (locale === "ru") return ru_voice_manager_styles_count_badge(inputs)
	if (locale === "es") return es_voice_manager_styles_count_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_styles_count_badge(inputs)
	if (locale === "ja") return ja_voice_manager_styles_count_badge(inputs)
	if (locale === "hi") return hi_voice_manager_styles_count_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_styles_count_badge(inputs)
	return en_voice_manager_styles_count_badge(inputs)
});